import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLike, meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ProjectOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/project-operator/geometry-project-operator-node"
import {
    GeometryProjectOperatorNode,
    projectOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/project-operator/geometry-project-operator-node"

export type MeshGeometryProjectOperatorParameters = ProjectOperatorParameters<
    MeshGeometryAttributeLikeNode,
    MeshGeometryAttributeLikeNode,
    MeshGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<MeshGeometryProjectOperatorParameters> = {
    nodeClass: "MeshGeometryProjectOperator",
    validation: {
        parameters: projectOperatorParametersSchema(meshGeometryAttributeLike, meshGeometryAttributeLike, meshGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryProjectOperator
    extends GeometryProjectOperatorNode<2, MeshGeometryAttributeLikeNode, MeshGeometryAttributeLikeNode, MeshGeometryAttributeSetLikeNode>
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
